import React from 'react';
import PropTypes from 'prop-types';
import styles from './TransferableSelectList.scss';
import {DropTarget} from 'react-dnd';
import Spinner from '../../Spinner.jsx';

const spec = {
  drop: ({onItemsDropped}, monitor, component) => {
    onItemsDropped(monitor.getItem().items);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver()
  };
}

class TransferableSelectList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  handleScrollBottom = async (e) => {
    let {
      hasMore,
      onRequestMore
    } = this.props;
    if (hasMore && !this.state.loading && this.isNearBottom(e.target)) {
      this.setState({loading: true});
      await onRequestMore();
      this.setState({loading: false});
    }
  }

  isNearBottom = (element) => {
    return (element.scrollTop + element.clientHeight) >= (element.scrollHeight - 500);
  }

  render() {
    let {
      canDrop,
      children,
      connectDropTarget,
      dropPrompt,
      hasMore,
      isOver,
      loading,
      noResultsText,
    } = this.props;

    return connectDropTarget(
      <div
        className={`${styles.list} ${canDrop ? styles.dragging : ''} ${isOver ? styles.hover : ''}`}
        onScroll={this.handleScrollBottom}
      >
        {
          loading &&
          <div
            className={styles.noResults}
          >
            <Spinner
              style={{
                height: '50px',
                width: '50px',
              }}
            />
          </div>
        }
        {
          !loading && children.length === 0 && !canDrop &&
          <div
            className={styles.noResults}
          >
            {noResultsText}
          </div>
        }
        {
          !loading && !canDrop &&
            (
              children
            )
        }
        {
          !loading && canDrop &&
          <div className={styles.overlay}>
            {dropPrompt}
          </div>
        }
        {
          !loading && hasMore && !canDrop &&
          <div className={styles.loadingItems}>
            <Spinner />
          </div>
        }
      </div>
    );
  }
}

TransferableSelectList.propTypes = {
  children: PropTypes.node,
  hasMore: PropTypes.bool,
  onRequestMore: PropTypes.func,
  onItemsDropped: PropTypes.func.isRequired,
  dropPrompt: PropTypes.node.isRequired,
  canDrop: PropTypes.bool.isRequired,
  isOver: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  connectDropTarget: PropTypes.func.isRequired,
  noResultsText: PropTypes.node,
};

TransferableSelectList.defaultProps = {
  onRequestMore: () => {},
};

export default DropTarget(({type}) => type, spec, collect)(TransferableSelectList);